import { Table } from "antd";
import dayjs from "dayjs";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { CustomPopup, CustomTable } from "../../../components";
import DownlineDetailReport from "./components/DownlineDetailReport";
import { useGetDownlineOverview } from "./hooks/downlinereport.hooks";
import styles from "./style.module.scss";
const DownlineReport = () => {
  const { t } = useTranslation();
  const { data: overview, isLoading, isError } = useGetDownlineOverview({});
  const [openDetailDrawer, setOpenDetailDrawer] = useState(false);
  const [selectedStartAt, setSelectedStartAt] = useState(null);
  const [selectedEndAt, setSelectedEndAt] = useState(null);
  const [detailTitle, setDetailTitle] = useState("");

  const onOpenDetail = (start_at, end_at) => {
    const title = `${dayjs(start_at).year()} - ${t(
      `month.${(dayjs(start_at).month() + 101).toString().substring(1, 3)}`,
    )}`;
    setSelectedStartAt(start_at);
    setSelectedEndAt(end_at);
    setOpenDetailDrawer(true);
    setDetailTitle(title);
  };

  const resetDrawer = () => {
    setDetailTitle("");
    setSelectedStartAt(null);
    setSelectedEndAt(null);
  };

  const columns = [
    {
      title: t("normal.date"),
      width: 120,
      dataIndex: "start_at",
      key: "start_at",
      align: "center",
      render: (text, record, index) => {
        return (
          <div
            onClick={() => onOpenDetail(record.start_at, record.end_at)}
            className={styles.date}
          >{`${dayjs(record.start_at).year()} - ${t(
            `month.${(dayjs(record.start_at).month() + 101).toString().substring(1, 3)}`,
          )}`}</div>
        );
      },
    },
    {
      title: t("downlineReport.overview.table.register"),
      width: 80,
      dataIndex: "first_deposit_user_register_count",
      key: "first_deposit_user_register_count",
      align: "center",
      render: (text, record, index) => {
        return (
          <>{`${record.child_register_count} / ${record.first_deposit_user_register_count}`}</>
        );
      },
    },
    {
      title: t("downlineReport.overview.table.firstDeposit"),
      dataIndex: "first_deposit_user_count",
      key: "first_deposit_user_count",
      width: 80,
      align: "center",
    },
    {
      title: t("downlineReport.overview.table.depositBet"),
      dataIndex: "deposit_and_bet_user_count",
      key: "deposit_and_bet_user_count",
      width: 94,
      align: "center",
    },
  ];
  return (
    <div className={styles.container}>
      {isLoading ? (
        ""
      ) : isError ? (
        ""
      ) : (
        <CustomTable
          columns={columns}
          dataSource={overview.data.data}
          showInifineScroll={false}
          summary={() => {
            return (
              <Table.Summary fixed="top">
                <Table.Summary.Row>
                  <Table.Summary.Cell index={0}>
                    <div className={styles.summaryCell}>{t("normal.summary")}</div>
                  </Table.Summary.Cell>
                  <Table.Summary.Cell index={1} className={styles.summaryCell}>
                    -
                  </Table.Summary.Cell>
                  <Table.Summary.Cell index={2}>
                    <div className={`${styles.summaryCell} ${styles.content}`}>
                      {/* <div style={{ color: "#EFAD5B" }}> */}
                      {overview?.data?.first_deposit_user_count || 0}
                    </div>
                  </Table.Summary.Cell>
                  <Table.Summary.Cell index={3} className={styles.summaryCell}>
                    -
                  </Table.Summary.Cell>
                </Table.Summary.Row>
              </Table.Summary>
            );
          }}
        />
      )}
      <CustomPopup
        visible={openDetailDrawer}
        onClose={() => {
          setOpenDetailDrawer(false);
        }}
        afterClose={resetDrawer}
        title={detailTitle}
        destroyOnClose={true}
        forceRender={true}
      >
        <DownlineDetailReport startAt={selectedStartAt} endAt={selectedEndAt} />
      </CustomPopup>
    </div>
  );
};

export default DownlineReport;
